import StatisticsContainer from './statistics_container';

const Statistics = StatisticsContainer;
export default Statistics;
